import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
`;

export const Paragraph = styled.p`
  font-size: ${16 / 16}rem;
`;
